import React, { PureComponent } from 'react';
import TextInput from 'components/TextInput';
import PropTypes from 'prop-types';
import Base from './Base';

const propTypes = {
    autoFocus: PropTypes.bool,
    canClear: PropTypes.bool,
    canToggle: PropTypes.bool,
    className: PropTypes.string,
    description: PropTypes.string,
    error: PropTypes.any,
    fieldExtraValue: PropTypes.any,
    hidden: PropTypes.bool,
    hint: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    inputType: PropTypes.string,
    isBulkAction: PropTypes.bool,
    isDuplicate: PropTypes.bool,
    isDuplicateLoading: PropTypes.bool,
    isSafeNumber: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    labelMode: PropTypes.string,
    limitInput: PropTypes.number,
    mandatory: PropTypes.bool,
    maxLength: PropTypes.number,
    onChange: PropTypes.func,
    onClear: PropTypes.func,
    onEnter: PropTypes.func,
    readOnly: PropTypes.bool,
    rows: PropTypes.number,
    size: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    willBeCleared: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

class TextInputField extends PureComponent {
    state = {};

    constructor(props) {
        super(props);
    }

    onChange = (value) => {
        const { onChange } = this.props;
        onChange && onChange(value);
    };

    onInput = (value) => {
        const { onInput } = this.props;
        onInput && onInput(value);
    };

    onEnter = (value) => {
        const { onEnter } = this.props;
        onEnter && onEnter(value);
    };

    render() {
        const {
            autoFocus,
            canClear,
            canToggle,
            description,
            error,
            fieldExtraValue,
            hidden,
            hint,
            inputType = 'text',
            isBulkAction,
            isDuplicate,
            isDuplicateLoading,
            isSafeNumber,
            label,
            labelMode,
            limitInput,
            mandatory,
            maxLength,
            readOnly,
            size,
            type,
            value = '',
            willBeCleared,
        } = this.props;

        if (hidden) return null;

        let classes = ['fm-field-textinput'];
        if (size && size === 'large') classes.push('fm-field-textinput__large');
        else if (size && size === 'xlarge') classes.push('fm-field-textinput__xlarge');
        if (readOnly) classes.push('fm-field-textinput__disabled');

        return (
            <div className={classes.join(' ')}>
                <Base
                    canClear={canClear}
                    label={label}
                    mandatory={mandatory}
                    description={description}
                    labelMode={labelMode}
                    isBulkAction={isBulkAction}
                    onClear={this.props.onClear}
                    onReset={this.props.onChange}
                    isDuplicate={isDuplicate}
                    canToggle={canToggle}
                    fieldExtraValue={fieldExtraValue}
                    willBeCleared={willBeCleared}
                >
                    <TextInput
                        type={type}
                        placeholder={hint}
                        inputType={inputType}
                        onChange={this.onChange}
                        onInput={this.onInput}
                        onEnter={this.onEnter}
                        value={value || null}
                        error={error}
                        maxLength={maxLength}
                        limitInput={limitInput}
                        disabled={!!willBeCleared || readOnly}
                        isLoading={isDuplicateLoading}
                        blurOnEnter={true}
                        autoFocus={autoFocus}
                        isSafeNumber={isSafeNumber}
                    />
                </Base>
            </div>
        );
    }
}

TextInputField.propTypes = propTypes;

export default TextInputField;
